/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "正在加载"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var zhCN = Object.assign(TranslationProviderComponent, {
  translations
});

export { zhCN as z };
//# sourceMappingURL=zh-CN-C_psRSc2.js.map
